import React from "react";
import {
  MenuItem,
  Select,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { CryptoState } from "../CryptoContext";
import { Theme } from "../theme";
import getColorsHook from "../getColorsHook";
import classNames from "./style.module.css";

const Header = () => {
  const history = useHistory();

  const { currency, setCurrency, theme, setTheme } = CryptoState();

  const [colors] = getColorsHook();
  const styles = {
    title: {
      flex: 1,
      color: colors.text2,
      cursor: "pointer",
      fontSize: "3vw",
    },
  };

  return (
    <div style={{ background: colors.bg2 }} className={classNames.header}>
      <div style={styles.title} onClick={() => history.push("/")}>
        CrypTracker
      </div>

      <ToggleButtonGroup
        value={theme}
        exclusive
        onChange={(e) => setTheme(e.target.value)}
      >
        <ToggleButton value={Theme.Night}>🌙</ToggleButton>
        <ToggleButton value={Theme.Day}>🌄</ToggleButton>
        <ToggleButton value={Theme.Candy}>🍒</ToggleButton>
      </ToggleButtonGroup>
      <Select
        value={currency}
        variant="outlined"
        style={{
          width: 100,
          height: 40,
          margin: "0px 20px",
          opacity: "50%",
          background: colors.bgContrast,
          color: colors.text2,
        }}
        onChange={(e) => setCurrency(e.target.value)}
      >
        <MenuItem value="USD">USD</MenuItem>
        <MenuItem value="INR">INR</MenuItem>
      </Select>
    </div>
  );
};

export default Header;
